import React, { useLayoutEffect, useMemo, useRef, useState } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useTheme } from '../ThemeContext';
import '../v2/styles/tokens.css';
import './StaffV2.css';

let mountedScopes = 0;
const modalProperties = ['bg', 'surface', 'sunken', 'border', 'border-strong', 'text', 'text-secondary', 'text-muted', 'accent', 'accent-hover', 'accent-subtle', 'accent-border', 'danger', 'danger-subtle', 'success', 'success-subtle', 'warning', 'warning-subtle'];
// Read the same CSS tokens as the customer portal rather than maintaining a second palette.
export function readStaffPalette(node) {
  const style = getComputedStyle(node);
  const value = name => style.getPropertyValue(`--v2-${name}`).trim();
  if (!value('bg')) return null; // Styles are mocked in component tests.
  return { primary: { main: value('accent'), contrastText: '#fff' }, secondary: { main: value('accent'), contrastText: '#fff' },
    error: { main: value('danger') }, warning: { main: value('warning') }, success: { main: value('success') },
    background: { default: value('bg'), paper: value('surface') },
    text: { primary: value('text'), secondary: value('text-secondary') }, divider: value('border') };
}
export default function StaffDesign({ children, className = '', style }) {
  const { isDarkMode } = useTheme();
  const root = useRef(null); const [palette, setPalette] = useState(null);
  const theme = useMemo(() => createTheme({
    palette: { mode: isDarkMode ? 'dark' : 'light', ...(palette || {}) },
    typography: { fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', fontSize: 13 },
    shape: { borderRadius: 8 },
    components: {
      MuiButton: { defaultProps: { disableElevation: true }, styleOverrides: { root: { textTransform: 'none', fontWeight: 600 } } },
      MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
      MuiTableCell: { styleOverrides: { root: { fontSize: 13 }, head: { fontWeight: 600 } } },
    },
  }), [isDarkMode, palette]);
  useLayoutEffect(() => {
    const computed = getComputedStyle(root.current); setPalette(readStaffPalette(root.current));
    mountedScopes++; document.body.dataset.staffTheme = isDarkMode ? 'dark' : 'light';
    for (const name of modalProperties) document.body.style.setProperty(`--staff-modal-${name}`, computed.getPropertyValue(`--v2-${name}`));
    return () => { if (--mountedScopes === 0) {
      delete document.body.dataset.staffTheme;
      for (const name of modalProperties) document.body.style.removeProperty(`--staff-modal-${name}`);
    } };
  }, [isDarkMode]);
  return <ThemeProvider theme={theme}><div ref={root} className={`v2 staff-v2${isDarkMode ? ' dark' : ''} ${className}`} style={style}>{children}</div></ThemeProvider>;
}
